let protooPort = 4443;

export function getProtooUrl({ roomId, peerId })
{
	//const hostname = window.location.hostname === 'c5n.910rocket.ontheory.net' ? '910rocket.ontheory.net' : window.location.hostname;

	const hostname =  'laboum01.laboum.live';
	return `wss://${hostname}:${protooPort}/?roomId=${roomId}&peerId=${peerId}`;
}
